import React from 'react'
import { FormControlLabel, Switch } from '@material-ui/core'

type CustomSwitchProps = {
  id: string
  label?: string
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom'
  size?: 'small' | 'medium'
  disabled?: boolean
  value: boolean
  onChange(value: boolean): void
}

export const CustomSwitch = (props: CustomSwitchProps) => {
  const { id, label, labelPlacement = 'end', size = 'small', disabled, value, onChange } = props

  return (
    <FormControlLabel
      id={id}
      control={<Switch size={size} disabled={disabled} checked={value} onChange={(e, chk) => onChange(chk)} />}
      label={label}
      labelPlacement={labelPlacement}
    />
  )
}
